import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { DATABASE_TYPE_NAMES } from '../../../utils/databases'
import AuthPage, { Sidebar } from '../../Shared/AuthPage'
import Card from '../../Shared/Card'
import Button from '../../Shared/Button'
import { FormWrapper } from '../New'
import AppLoader from '../../App/AppLoader'
import DatabaseType from './DatabaseType'

import styles from './InitialSetup.module.css'

export default function InitialSetup() {
  const [type, setType] = useState(null)
  const [formVisible, setFormVisible] = useState(false)

  const history = useHistory()

  const handleSuccess = useCallback(
    result => {
      history.push('/databases/view-setup')
    },
    [history]
  )

  const toggleForm = useCallback(() => {
    setFormVisible(!formVisible)
  }, [setFormVisible, formVisible])

  return (
    <AppLoader>
      <AuthPage>
        {formVisible ? (
          <FormWrapper
            hideType
            initialValues={{ type }}
            title={`Connect to ${DATABASE_TYPE_NAMES[type]}`}
            subtitle="Enter your datasource details to connect."
            onSuccess={handleSuccess}
            onCancel={toggleForm}
            cancelButtonText="Back"
          />
        ) : (
          <DatabaseType onSubmit={toggleForm} type={type} setType={setType} />
        )}
        <Sidebar>
          <Card
            leftAligned
            actions={
              <Button
                xs
                color="grey"
                to="https://docs.easybutton.io/"
                target="_blank"
              >
                Read More
              </Button>
            }
          >
            <h3>How safe is my data?</h3>
            <p className={styles.explainer}>
              We need to connect to your database in order to allow you to view
              your data & build against against it. We never store your data
              (aside from Firebase search and logs), and we never access your
              database unless you tell us to.
            </p>
          </Card>
        </Sidebar>
      </AuthPage>
    </AppLoader>
  )
}
